
/**
 * NOTE: This is an AUTO GENERATED file from the Translation strings. If new languages are added,
 * then this file needs to be regenerated from the source CHATBOT translations. If used in Pleased
 * Application, only use the `language.ts` file generated by this method.
 *
 * NOTE: This file is created via AppScript. You can edit the JS code it in the link below.
 *
 * @see https://docs.google.com/spreadsheets/d/1cuSl1W_ZTA2fVdjJziyk7j5oIioBrKpLzd8Zwz5t8X8
 * @author Aakash More
 */

/**
 * Static list of languages supported by the pleased app.
 */
export const LANGUAGES = {
  en: {
    code: 'en',
    englishName: '',
    locale: 'en',
    name: 'English',
  },
  es: {
    code: 'es',
    englishName: 'Spanish',
    locale: 'es',
    name: 'Español',
  },
  fr: {
    code: 'fr',
    englishName: 'French',
    locale: 'fr',
    name: 'Français',
  },
  pt: {
    code: 'pt',
    englishName: 'Brazilian Portuguese',
    locale: 'pt',
    name: 'Português do Brasil',
  },
  sw: {
    code: 'sw',
    englishName: 'Swahili',
    locale: 'sw',
    name: 'Kiswahili',
  },
} as const;

export type SupportedLanguages = keyof typeof LANGUAGES;
